<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                There was a problem completing the purchase. You can <a class='underline' href='/verified/review'>try again</a>, or contact support for help.
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";



export default {
    name: 'A2P-Problem-Purchasing',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        exampleSelectable,
    },
    data() {
        return {
            form: this.$inertia.form(
                {
                    _method: "POST",
                    step: 'review',
                },
                {
                }
            ),
        }
    },
    computed: {
       
    },
    mounted() {

    },
    methods: {
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>
</style>
